import { CheckIcon, CloseIcon, WarningIcon } from '@chakra-ui/icons';
import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';

interface CustomToastRenderProps {
    onClose: () => void;
    status: "success" | "error" | "warning" | "info";
    customText?: string;
    allowHtml?: boolean;
    testId?: string;
}

const CustomToastRender = ({ onClose, status, customText, allowHtml = false, testId }: CustomToastRenderProps) => {
    const statusColor = {
        success: "green.500",
        error: "red.500",
        warning: "yellow.500",
        info: "blue.500",
    }[status];

    const statusText = {
        success: "Merchant Profile successfully updated",
        error: "Operation completed Failed",
        warning: "Warning!",
        info: "Info!",
    }[status];

    const statusIcon = {
        success: <CheckIcon boxSize={4} color="white" />,
        error: <WarningIcon boxSize={4} color="white" />,
        warning: <WarningIcon boxSize={4} color="white" />,
        info: <CheckIcon boxSize={4} color="white" />,
    }[status];

    return (<Box
        color="white"
        p={3}
        bg={statusColor}
        borderRadius="md"
        display="flex"
        alignItems="center"
        gap="8px"
        justifyContent={"space-between"}
        data-testid={testId}
    >
        <div className="flex gap-2 items-center">
            {statusIcon}
            {allowHtml ? (
                <div
                    className="text-sm"
                    style={{ color: 'white' }}
                    dangerouslySetInnerHTML={{ __html: customText ?? statusText }}
                />
            ) : (
                <Text textColor="white" className="text-sm">
                    {customText ?? statusText}
                </Text>
            )}
        </div>


        <Button
            size="sm"
            onClick={onClose}
            bg="transparent"
            color="white"
            width="20px"
            _hover={{ bg: "whiteAlpha.300" }}
            _focus={{ boxShadow: "none" }}
        >
            <CloseIcon color="white" />
        </Button>
    </Box>)
}

export default CustomToastRender;